<template>
  <v-container fluid>
    <PageHeaderSlot />
    <v-form ref="dataForm" @submit.prevent>
      <v-card class="mb-8">
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormFileUploader
                uploadText="uploadLogo"
                fileInputKey="upload_logo"
                :files.sync="formData.logo_list"
                acceptFormat="image"
                dispatchUpdateOnChange
                single
              />
            </v-col>
            <v-col cols="12">
              <FormTextarea
                label="invoiceRemark"
                :fieldValue.sync="formData.custom_text"
                dense
                dispatchUpdateOnChange
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="tel"
                label="phone"
                placeholder="phone"
                :fieldValue.sync="formData.phone"
                dense
                isIntegerOnly
                dispatchUpdateOnChange
              />
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="email"
                label="email"
                placeholder="email"
                :fieldValue.sync="formData.email"
                dense
                dispatchUpdateOnChange
              />
            </v-col>
            <v-col cols="12" v-if="enableOnlinePayment">
              <FormTextarea
                label="defaultWhatsappMsg"
                :fieldValue.sync="formData.whatsapp_message"
                dense
                dispatchUpdateOnChange
              />
            </v-col>
            <v-col cols="12">
              <FormTextarea
                :label="$t('enrollTerms')"
                :fieldValue.sync="formData.member_terms_field"
                dense
                dispatchUpdateOnChange
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <template v-if="enableOnlinePayment">
        <h2 class="text-h6 mb-2">{{ $t('paymentSetting') }}</h2>
        <v-card class="mb-4">
          <v-card-text class="px-2">
            <v-row class="ma-0">
              <v-col cols="12">
                <v-checkbox v-model="formData.accept_payment_methods" value="payme">
                  <template v-slot:label>
                    <div class="text-subtitle-1 colorBlack--text font-weight-medium">
                      {{ $t('paymePaymentInfo') }}<small class="text-caption">{{ $t('useWithOnlinePayment') }}</small>
                    </div>
                  </template>
                </v-checkbox>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <FormInput
                  type="tel"
                  label="paymePhone"
                  placeholder="paymePhone"
                  :fieldValue.sync="formData.payme_phone"
                  dense
                  isIntegerOnly
                  dispatchUpdateOnChange
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormFileUploader
                  uploadText="uploadPaymeImg"
                  fileInputKey="upload_payme"
                  :files.sync="formData.payme_code"
                  acceptFormat="image"
                  dispatchUpdateOnChange
                  single
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-4">
          <v-card-text class="px-2">
            <v-row class="ma-0">
              <v-col cols="12">
                <v-checkbox v-model="formData.accept_payment_methods" value="fps">
                  <template v-slot:label>
                    <div class="text-subtitle-1 colorBlack--text font-weight-medium">
                      {{ $t('fpsPaymentInfo') }}<small class="text-caption">{{ $t('useWithOnlinePayment') }}</small>
                    </div>
                  </template>
                </v-checkbox>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <FormInput
                  type="number"
                  label="fpsId"
                  placeholder="fpsId"
                  :fieldValue.sync="formData.fps_id"
                  dense
                  isIntegerOnly
                  dispatchUpdateOnChange
                />
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormFileUploader
                  uploadText="uploadFPSImg"
                  fileInputKey="upload_fps"
                  :files.sync="formData.fps_code"
                  acceptFormat="image"
                  dispatchUpdateOnChange
                  single
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-4">
          <v-card-text class="px-2">
            <v-row class="ma-0">
              <v-col cols="12">
                <v-checkbox v-model="formData.accept_payment_methods" value="wechat_pay">
                  <template v-slot:label>
                    <div class="text-subtitle-1 colorBlack--text font-weight-medium">
                      {{ $t('wechatPaymentInfo') }}<small class="text-caption">{{ $t('useWithOnlinePayment') }}</small>
                    </div>
                  </template>
                </v-checkbox>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormFileUploader
                  uploadText="uploadWechatImg"
                  fileInputKey="upload_wechat"
                  :files.sync="formData.wechat_code"
                  acceptFormat="image"
                  dispatchUpdateOnChange
                  single
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-4">
          <v-card-text class="px-2">
            <v-row class="ma-0">
              <v-col cols="12">
                <v-checkbox v-model="formData.accept_payment_methods" value="alipay">
                  <template v-slot:label>
                    <div class="text-subtitle-1 colorBlack--text font-weight-medium">
                      {{ $t('alipayPaymentInfo') }}<small class="text-caption">{{ $t('useWithOnlinePayment') }}</small>
                    </div>
                  </template>
                </v-checkbox>
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3">
                <FormFileUploader
                  uploadText="uploadAlipayImg"
                  fileInputKey="upload_alipay"
                  :files.sync="formData.alipay_code"
                  acceptFormat="image"
                  dispatchUpdateOnChange
                  single
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-4">
          <v-card-text class="px-2">
            <v-row class="ma-0">
              <v-col cols="12">
                <v-row class="ma-0 pa-0 justify-space-between">
                  <v-checkbox v-model="formData.accept_payment_methods" value="bank_transfer">
                    <template v-slot:label>
                      <div class="text-subtitle-1 colorBlack--text font-weight-medium">
                        {{ $t('bankPaymentInfo') }}<small class="text-caption">{{ $t('useWithOnlinePayment') }}</small>
                      </div>
                    </template>
                  </v-checkbox>
                  <FormButton text="addBank" class="ml-4 my-2" isAdd @click="handleBankInfoOpen('new')" />
                </v-row>
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12">
                <Datatable
                  class="mt-6"
                  :isLoading="tableLoading"
                  :tableData="tableData"
                  :tableHeaders="tableHeaders"
                  disablePagination
                  @edit-clicked="handleBankInfoOpen('edit', $event)"
                  @delete-clicked="handleDeleteBankInfo($event)"
                ></Datatable>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </template>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
      </div>
    </v-form>

    <!-- Modal: 新增銀行 -->
    <FormDialog
      :title="bankFormData.type === 'edit' ? 'editBank' : 'addBank'"
      :maxWidth="910"
      ref="bankDialog"
      formRef="bankForm"
      @submit-clicked="handleBankInfoSubmit()"
    >
      <v-row class="ma-0">
        <v-col cols="12" md="6">
          <FormInput label="bankName" placeholder="bankName" :fieldValue.sync="bankFormData.bank_name" dense required />
        </v-col>
        <v-col cols="12" md="6">
          <FormInput
            label="beneficiaryName"
            placeholder="beneficiaryName"
            :fieldValue.sync="bankFormData.beneficiary_name"
            dense
            required
          />
        </v-col>
        <v-col cols="12" md="6">
          <FormInput
            label="accountNumber"
            placeholder="accountNumber"
            :fieldValue.sync="bankFormData.account_number"
            dense
            required
          />
        </v-col>
      </v-row>
    </FormDialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import FormFileUploader from '@/components/formField/FormFileUploader.vue'
import FormTextarea from '@/components/formField/FormTextarea.vue'
import FormInput from '@/components/formField/FormInput.vue'
import Datatable from '@/components/Datatable.vue'
import FormDialog from '@/components/FormDialog.vue'

export default {
  name: 'Setting',
  components: {
    FormFileUploader,
    FormTextarea,
    FormInput,
    Datatable,
    FormDialog,
  },
  computed: {
    // permission / setting
    enableOnlinePayment() {
      return process.env.VUE_APP_ENABLE_ONLINE_PAYMENT && process.env.VUE_APP_ENABLE_ONLINE_PAYMENT === 'true'
    },
  },
  data: vm => ({
    formData: {
      logo_list: [],
      custom_text: '',
      phone: '',
      email: '',
      whatsapp_message: '',
      accept_payment_methods: [],
      payme_phone: '',
      payme_code: [],
      fps_id: '',
      fps_code: [],
      wechat_phone: '',
      wechat_code: [],
      alipay_phone: '',
      alipay_code: [],
      member_terms_field: '',
    },

    tableLoading: true,
    tableData: [],
    tableHeaders: [
      { value: 'bank_name', text: vm.$t('bankName') },
      { value: 'beneficiary_name', text: vm.$t('beneficiaryName') },
      { value: 'account_number', text: vm.$t('accountNumber') },
      { value: 'minActionEditAndDelete', text: '', align: 'end' },
    ],
    rowId: 0,
    bankFormData: {
      type: '',
      bank_name: '',
      beneficiary_name: '',
      account_number: '',
    },
  }),
  methods: {
    ...mapActions(['setLeaveDialogLink', 'setShowLeaveDialog']),
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
        if (data['logo']) {
          this.formData.logo_list.push({ name: data['logo'], file: data['logo'] })
        }

        if (data['payment_info_payme']) {
          this.$set(this.formData, 'payme_phone', data['payment_info_payme'].number)
          if (data['payment_info_payme'].code) {
            this.formData.payme_code.push(data['payment_info_payme'].code)
          }
        }
        if (data['payment_info_fps']) {
          this.$set(this.formData, 'fps_id', data['payment_info_fps'].number)
          if (data['payment_info_fps'].code) {
            this.formData.fps_code.push(data['payment_info_fps'].code)
          }
        }
        if (data['payment_info_wechat_pay']) {
          this.$set(this.formData, 'wechat_phone', data['payment_info_wechat_pay'].number)
          if (data['payment_info_wechat_pay'].code) {
            this.formData.wechat_code.push(data['payment_info_wechat_pay'].code)
          }
        }
        if (data['payment_info_alipay']) {
          this.$set(this.formData, 'alipay_phone', data['payment_info_alipay'].number)
          if (data['payment_info_alipay'].code) {
            this.formData.alipay_code.push(data['payment_info_alipay'].code)
          }
        }

        if (data['payment_info_bank_transfer']) {
          data['payment_info_bank_transfer'].forEach(el => {
            this.tableData.push({
              id: this.rowId,
              ...el,
            })

            this.rowId += 1
          })
        }

        try {
          const selectedCenter = await this.getUserSelectedCenter()
          const center_data = await this.$Fetcher.GetCenterById(selectedCenter)
          if(center_data.logo != undefined && center_data.logo != null){
            this.formData['logo_list'] = []
            this.formData.logo_list.push({ name: center_data['logo'], file: center_data['logo'] })
          }
          if(center_data.custom_text != undefined && center_data.custom_text != null){
            this.formData['custom_text'] = center_data.custom_text
          }
          if(center_data.member_terms_field != undefined && center_data.member_terms_field != null){
            this.formData['member_terms_field'] = center_data.member_terms_field
          }
          if(center_data.email != undefined && center_data.email != null){
            this.formData['email'] = center_data.email
          }
          if(center_data.phone != undefined && center_data.phone != null){
            this.formData['phone'] = center_data.phone
          }

        } catch (err) {
          this.$common.error(err)
        } finally {
          this.$store.dispatch('toggleLoadingPage', false)
          this.tableLoading = false
        }
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('toggleLoadingPage', false)
        this.tableLoading = false
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = await this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)

      let payload = {
        logo: this.formData.logo_list.length ? this.formData.logo_list[0].file : '',
        custom_text: this.formData.custom_text,
        phone: this.formData.phone,
        email: this.formData.email,
        // whatsapp_message: this.formData.whatsapp_message,
        member_terms_field: this.formData.member_terms_field,

        // payment_info_payme: {
        //   number: this.formData.payme_phone,
        //   code: this.formData.payme_code.length ? this.formData.payme_code[0] : '',
        // },
        // payment_info_fps: {
        //   number: this.formData.fps_id,
        //   code: this.formData.fps_code.length ? this.formData.fps_code[0] : '',
        // },
        // payment_info_wechat_pay: {
        //   number: this.formData.wechat_phone,
        //   code: this.formData.wechat_code.length ? this.formData.wechat_code[0] : '',
        // },
        // payment_info_alipay: {
        //   number: this.formData.alipay_phone,
        //   code: this.formData.alipay_code.length ? this.formData.alipay_code[0] : '',
        // },
        // payment_info_bank_transfer: this.tableData.map(el => {
        //   return {
        //     bank_name: el.bank_name,
        //     beneficiary_name: el.beneficiary_name,
        //     account_number: el.account_number,
        //   }
        // }),
        // accept_payment_methods: this.formData.accept_payment_methods,
      }

      try {
        // await this.$Fetcher.UpdateSetting(payload)
        const selectedCenter = await this.getUserSelectedCenter()
        await this.$Fetcher.UpdateCenter(selectedCenter, payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    // ======== 新增銀行 =======
    handleBankInfoOpen(type, id) {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }
      this.$set(this.bankFormData, 'type', type)

      // -- reset form
      this.$set(this.bankFormData, 'bank_name', '')
      this.$set(this.bankFormData, 'beneficiary_name', '')
      this.$set(this.bankFormData, 'account_number', '')

      if (type === 'edit' && this.$validate.DataValid(id)) {
        this.$refs['bankDialog'].setEditId(id)

        const target = this.tableData.find(el => el.id === id)
        if (target) {
          this.$set(this.bankFormData, 'bank_name', target.bank_name)
          this.$set(this.bankFormData, 'beneficiary_name', target.beneficiary_name)
          this.$set(this.bankFormData, 'account_number', target.account_number)
        }
      }

      if (type === 'new' || (type === 'edit' && this.$validate.DataValid(id))) {
        this.$refs['bankDialog'].show()
      }
    },
    async handleBankInfoSubmit() {
      if (this.bankFormData.type === 'edit') {
        const editId = this.$refs['bankDialog'].getEditId()
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].id === editId) {
            this.$set(this.tableData[i], 'bank_name', this.bankFormData.bank_name)
            this.$set(this.tableData[i], 'beneficiary_name', this.bankFormData.beneficiary_name)
            this.$set(this.tableData[i], 'account_number', this.bankFormData.account_number)
            break
          }
        }
      } else {
        this.tableData.push({
          id: this.rowId,
          bank_name: this.bankFormData.bank_name,
          beneficiary_name: this.bankFormData.beneficiary_name,
          account_number: this.bankFormData.account_number,
        })
        this.rowId += 1
      }

      await this.$refs['bankDialog'].resetForm()
      this.$refs['bankDialog'].hide()
    },
    handleDeleteBankInfo(id) {
      const targetPos = this.tableData.findIndex(el => el.id === id)
      if (targetPos > -1) {
        this.tableData.splice(targetPos, 1)
      }
    },

    async handleSiteLoaded() {
      console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: Setting')
      this.getSetting()
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.setLeaveDialogLink({ name: to.name })
      this.setShowLeaveDialog(true)
      next(false)
    } else {
      next()
    }
  },
}
</script>
